import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=775edd14&scoped=true"
var script = {}
import style0 from "./Container.vue?vue&type=style&index=0&id=775edd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775edd14",
  null
  
)

export default component.exports